(() => {
  if (window.Analytics) return;
  if (!window.posthog) return;

  const CART_ATTRIBUTE = 'posthog_distinct_id';

  function commonProperties() {
    return {
      url: location.href, //window.location.href
      path: location.pathname,
      title: document.title,
      referrer: document.referrer || null,
      locale: Shopify?.locale || null,
      currency: Shopify?.currency?.active || null,
      theme: 'Dawn',
      theme_version: '15.4.0'
    };
  }

  function track(event, properties = {}) {
    posthog.capture(event, {
      ...commonProperties(),
      ...properties
    });

    if (Shopify?.designMode) {
      console.log('[Analytics]', event, properties);
    }
  }

  function identify(id, properties = {}) {
    if (!id) return;
    posthog.identify(String(id), properties);
  }

  function reset() {
    posthog.reset();
  }

  async function getCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }

  async function syncDistinctId() {
    try {
      const distinctId = posthog.get_distinct_id();

      if (!distinctId) return;

      const cart = await getCart(); // slow page load?

      const current =
        cart.attributes?.[CART_ATTRIBUTE] ??
        null;

      if (current === distinctId) return;

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            [CART_ATTRIBUTE]: distinctId
          }
        })
      });

      console.log('[Analytics] synced distinct_id to cart');

    } catch (e) {
      console.error('[Analytics]', e);
    }
  }

  document.addEventListener('DOMContentLoaded', async () => {

    track('$pageview', {
      $current_url: location.href,
      $pathname: location.pathname
    });

    await syncDistinctId();

  });

  window.Analytics = {
    track,
    identify,
    reset
  };

})();